<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电卡信息</span>
      </div>
      <div class style="width:500px">
        <SForm
          ref="form"
          :fields="formfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          :inline="false"
          label-position="right"
        />
      </div>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Piaowuxiugai',
  components: {},
  data() {
    return {
      rowdata: {
        cardNum: '',
        physicalNum: ''
      },
      formfields: [
        {
          label: '卡面卡号',
          placeholder: '请输入卡面卡号',
          prop: 'cardNum',
          rules: { required: true, message: '请输入卡面卡号', trigger: 'blur' }
        },
        {
          label: '芯片码',
          placeholder: '请输入芯片码',
          prop: 'physicalNum',
          rules: { required: true, message: '请输入芯片码', trigger: 'blur' }
        }
      ],
      id: ''
    }
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: token
      }
    }
  },
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {

    cancel() {
      this.$router.go(-1)
    },

    save() {
      // try {
      //     //必填校验
      //     console.log(2222)
      //     await Promise.all([
      //         this.$refs.form.validate()
      //     ]);
      //     console.log(1111)
      // } catch (error) {
      //     return;
      // }
      this.rowdata.id = this.id
      this.$store.dispatch('form/handle', {
        url: '/user/chargingCard/post',
        data: this.rowdata,
        method: 'post',
        callback: resp => {
          this.$router.go(-1)
        }
      })
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/user/chargingCard/detail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata.cardNum = resp.cardNum
          this.rowdata.physicalNum = resp.physicalNum
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/chargingCard/chargingCardModify.vue